/**
 * Service layer per i template newsletter (§11.7).
 * - Template di entità: entity_id valorizzato (CRUD con NEWSLETTER W sull'entità).
 * - Template standard: entity_id = null (gestiti solo da admin nazionale; selezionabili da tutti i NEWSLETTER R).
 * - DELETE = archiviazione (is_archived = true), non eliminazione fisica.
 *
 * Riferimento: TDD Sprint 18 §4.2 / §8.4.
 */
import API from '../../api';

export const templatesApi = {
  /** GET /newsletter-templates — paginata (10/pagina); filtri opzionali { page, entity_id, is_archived, search }. */
  list: (params) => API.get('/newsletter-templates', { params }),

  /** GET /newsletter-templates/{id}. */
  get: (id) => API.get(`/newsletter-templates/${id}`),

  /** POST /newsletter-templates. */
  create: (payload) => API.post('/newsletter-templates', payload),

  /** PUT /newsletter-templates/{id}. */
  update: (id, payload) => API.put(`/newsletter-templates/${id}`, payload),

  /**
   * PATCH /newsletter-templates/{id}/archive — toggle archiviazione.
   * Inverte is_archived (archivia se attivo, ripristina se archiviato).
   * Risposta: { message, is_archived }.
   */
  toggleArchive: (id) => API.patch(`/newsletter-templates/${id}/archive`),

  /** POST /newsletter-templates/{id}/attachments — upload allegato (multipart). */
  addAttachment: (id, formData) =>
    API.post(`/newsletter-templates/${id}/attachments`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }),

  /** DELETE /newsletter-templates/{id}/attachments/{attId}. */
  removeAttachment: (id, attId) => API.delete(`/newsletter-templates/${id}/attachments/${attId}`),
};

export default templatesApi;